import { CInvoicingPriceAmountType } from '../types';

export class CInvoicingPriceAmount implements CInvoicingPriceAmountType {
  constructor(json: CInvoicingPriceAmountType) {
    Object.assign(this, json);
  }

  amount: number;
}
